<p>admin-configuration works!</p>
